import styled from 'styled-components';
import { colors, fonts } from '../../../styles/theme';
import { toRem } from '../../../utils';
import { Spinner } from '../../Spinner';
import { Button } from '../../Button';

type InputContainerProps = {
  readonly isNotAdmin?: boolean;
}

export const SelectStyles = (error?: string) => {
  const styles = {
    borderRadius: 2,
    option: (_: any, { isFocused }: any) => ({
      color: colors.color1,
      backgroundColor: isFocused && colors.color6,
      padding: 0,
      cursor: 'pointer',
      fontFamily: 'latoregular',
      fontSize: 14,
    }),
    placeholder: () => ({
      color: colors.color1,
      opacity: 0.4,
      fontSize: 14,
      gridArea: '1/1/2/3',
      marginLeft: 4,
      fontFamily: 'latoregular',
    }),
    control: (_: any, { isDisabled }: any) => ({
      '&:hover': { borderColor: colors.color1 },
      border: `1px solid ${error ? colors.color14 : colors.color3}`,
      boxShadow: 'none',
      display: 'flex',
      backgroundColor: isDisabled ? colors.color11 : colors.color4,
      minHeight: 40,
      cursor: 'pointer',
      borderRadius: 3,
      fontFamily: 'latoregular',
      fontSize: 14,
    }),
    multiValue: (baseStyles: any) => ({
      ...baseStyles,
      div: {
        fontSize: 14,
      },
    }),
  };

  return styles;
};

export const WrapperStyled = styled.div<InputContainerProps>`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
`;

export const LabelStyled = styled.label`
  display: flex;
  flex-direction: column;
`;

export const LabelTextStyled = styled.span`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  text-transform: uppercase;
  margin-bottom: ${toRem(8)};
  color: ${colors.color13};
  ${fonts.gotham.H12M}
`;

export const ErrorStyled = styled.span`
  margin-top: 0.3rem;
  color: ${colors.color14};
  ${fonts.lato.H14}
`;

export const SpinnerStyled = styled(Spinner)`
  margin-left: 0.5rem;
`;

export const DescriptionStyled = styled.span`
  color: ${colors.color13};
  ${fonts.lato.H14}
  margin-bottom: 0.5rem;
`;

export const HeaderStyled = styled.header`
  margin: 1rem;
  ${fonts.lato.H14R}
  color: ${colors.color1};
  line-height: 1.5;
`;

export const FooterStyled = styled(Button)`
  width: 100%;
  margin: 1rem 0;
  ${fonts.lato.H14M};
  color: ${colors.color2};
  line-height: 1.5;
  justify-content: flex-start;
  text-decoration: none;
`;

export const OptionWrapperStyled = styled.div`
  ${fonts.lato.H14};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid ${colors.color3};
`;

export const OptionLeftSideStyled = styled.div`
  width: 50%;
`;

export const OptionDateTextStyled = styled.div`
  ${fonts.lato.H14M};
  padding-bottom: 4px;
`;

export const OptionRightSideStyled = styled.div`
  ${fonts.lato.H12}
  display: flex;
  flex-direction: row;
  width: 50%;
  gap: 4px;
  justify-content: flex-end;
`;

export const SubTextStyled = styled.div`
  color: ${colors.color1};
  opacity: 0.4;
`;
